import React from "react";
import { Button, CircularProgress } from "@mui/material";
import { Base } from "../base";

interface Props {
  isSubmitting: boolean;
  text?: string;
  disabled?: boolean;
  type?: "primary" | "secondary" | "delete" | "active" | "inactive";
}

const FormikSubmitButton: React.FC<Props> = (props) => {
  const { isSubmitting, text, disabled, type } = props;

  return (
    <Button
      disabled={disabled ?? isSubmitting}
      type="submit"
      variant="contained"
      color={
        type === "active"
          ? "success"
          : type === "inactive"
          ? "info"
          : type === "secondary"
          ? "secondary"
          : type === "delete"
          ? "error"
          : "primary"
      }
    >
      <Base.Text text={text ?? "Submit"} />
      {isSubmitting && <CircularProgress size={20} sx={{ ml: 5 }} />}
    </Button>
  );
};

export default FormikSubmitButton;
